import { render, staticRenderFns } from "./CreateMember.vue?vue&type=template&id=01d4556d"
import script from "./CreateMember.vue?vue&type=script&lang=js"
export * from "./CreateMember.vue?vue&type=script&lang=js"
import style0 from "./CreateMember.vue?vue&type=style&index=0&id=01d4556d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports